import React, { useState } from 'react';
import { Dialog, DialogActions, DialogContent, Theme } from '@mui/material';
import { createStyles, makeStyles } from '@mui/styles';

import Button from '@/main/components/shared/button/button';
import SecondaryButton from '@/main/components/shared/button/secondaryButton';
import { getTranslateByKey } from '@/main/services/utils';
import * as S from './styles';
import { SpinnerLoading } from '../styles';
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      '& .MuiPaper-root': {
        padding: '1rem 1rem 1rem !important'
      }
    },
    actions: {
      padding: '1rem 0 0'
    },
    paper: {
      padding: '0'
    }
  })
);


interface IAsyncModalConfirmWithLoadingProps {
  label: string;
  isOpen: boolean;
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
  id?: string;
  closeByOverlay?: boolean;
  onConfirm?: () => Promise<void>;
  onCancel?: () => void;
}
const AsyncModalConfirmWithLoading = ({
  label,
  isOpen,
  setIsOpen,
  id,
  closeByOverlay = false,
  onCancel = async () => { },
  onConfirm = async () => { }
}: IAsyncModalConfirmWithLoadingProps): JSX.Element => {
  const classes = useStyles();
  const [isLoading, setIsLoading] = useState(false);

  const handleClose = (
    event: {},
    reason: 'backdropClick' | 'escapeKeyDown'
  ) => {
    if (closeByOverlay) {
      setIsOpen(false);
    }
  };

  async function handleClickNo(e: React.MouseEvent<HTMLButtonElement>) {
    e.preventDefault();
    e.stopPropagation();

    await onCancel();
  }
  async function handleClickYes(e: React.MouseEvent<HTMLButtonElement>) {
    e.preventDefault();
    e.stopPropagation();

    setIsLoading(true);

    try {
      await onConfirm();
    } finally {
      setIsLoading(false);
    }
  }

  return (
    <Dialog
      id={id}
      open={isOpen}
      className={classes.root}
      onClose={handleClose}
    >
      <DialogContent className={classes.paper}>
        <S.Text>
          {label}
        </S.Text>
      </DialogContent>
      <DialogActions
        className={classes.actions}
      >
        <S.AreaFooterButtons>
          <SecondaryButton
            id="id-btn-no"
            disabled={isLoading}
            onClick={handleClickNo}
          >
            {getTranslateByKey('information.no')}
          </SecondaryButton>
          <Button
            id="id-btn-yes"
            disabled={isLoading}
            isLoading={isLoading}
            onClick={handleClickYes}
          >
            {getTranslateByKey('information.yes')}
          </Button>
        </S.AreaFooterButtons>
      </DialogActions>
    </Dialog>
  )
};


export default AsyncModalConfirmWithLoading;
